import * as Sentry from "@sentry/react";

export const registerGlobalRuntimeErrorHandlers = (): void => {
  window.addEventListener("error", (event) => {
    if (event.error) {
      Sentry.captureException(event.error);
    }
  });

  window.addEventListener("unhandledrejection", (event) => {
    const reason = event.reason instanceof Error ? event.reason : new Error(String(event.reason));
    Sentry.captureException(reason);
  });
};

export const getReactRootErrorHandlers = () => ({
  onCaughtError(error: unknown, errorInfo: { componentStack?: string }) {
    Sentry.withScope((scope) => {
      scope.setTag("source", "react_root");
      scope.setTag("kind", "caught_error");
      scope.setContext("react", {
        componentStack: errorInfo.componentStack ?? null,
      });
      Sentry.captureException(error);
    });
  },
  onUncaughtError(error: unknown, errorInfo: { componentStack?: string }) {
    Sentry.withScope((scope) => {
      scope.setTag("source", "react_root");
      scope.setTag("kind", "uncaught_error");
      scope.setContext("react", {
        componentStack: errorInfo.componentStack ?? null,
      });
      Sentry.captureException(error);
    });
  },
  onRecoverableError(error: unknown, errorInfo: { componentStack?: string }) {
    Sentry.withScope((scope) => {
      scope.setTag("source", "react_root");
      scope.setTag("kind", "recoverable_error");
      scope.setContext("react", {
        componentStack: errorInfo.componentStack ?? null,
      });
      Sentry.captureException(error);
    });
  },
});
